<div style="width: 90vw">
  <div class="zone" *ngFor="let zone of zones; let i = index">
    <div class="zoneTitle">
      Zone {{ 5 - i }}
      <span class="zoneZones"
        >{{ i === 0 ? "> " : "" }} {{ zone.limitDown }}
        {{ i === 0 ? "" : "- " + zone.limitUp }} bpm · {{ zone.name }}
      </span>
    </div>
    <div class="bottomLine">
      <div class="meter">
        <span
          [style.background]="zone.color"
          [style.width]="zone.percentage + '%'"
        ></span>
      </div>
      <span style="float: right">{{ zone.duration | elapsed }}</span>
      <span style="float: right">{{ zone.percentage }}%</span>
    </div>
  </div>
</div>
